// socket.js
import { io } from 'socket.io-client';
import { Environment } from './constants/appConstants';
const baseUrl = () => {
  let BASE_URL = '';
  if (Environment === 'Development') {
    BASE_URL = 'https://dev-api-v2.beinghumans.co';
  } else if (Environment === 'Production') {
    BASE_URL = 'https://api-v2.beiinghuman.com';
  } else if (Environment === 'Staging') {
    BASE_URL = 'https://staging-backend.beiinghuman.com';
  } else {
    BASE_URL = 'http://localhost:3000';
  }
  return BASE_URL;
};
const socket = io(baseUrl(), {
  autoConnect: false,
  transports: ['websocket']
});

// Emitted by the backend to every user of a company after a settings save
// (userHandlerV2.updateUser). Payload: { companyId, changedKeys, by, at }.
export const COMPANY_SETTINGS_UPDATED_EVENT = 'company-settings-updated';

export default socket;
